import React, { Component } from 'react';
import 'primereact/resources/themes/nova-light/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Dialog } from 'primereact/dialog';
import { Dropdown } from 'primereact/dropdown';
import UserService from '../../services/UserService';
import CartonMasterService from '../../services/CartonMasterService';
import TertiaryPackingService from '../../services/TertiaryPackingService';
import MappingService from '../../services/MappingService';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import tableRequest from '../../models/tableRequest.js';
import { confirmAlert } from 'react-confirm-alert'; // Import
import { ConfirmationModal } from '../../template/ConfirmationModal';
import MessageComponent from '../../template/Message';
import $ from 'jquery';
import PrintSecondaryPackagingService from '../../services/PrintSecondaryPackagingService';
import Loaders from '../../template/Loaders';
export default class TertiaryPacking extends Component {
    constructor(props) {
        super(props);
        // this.UserService = new UserService();
        this.CartonMasterService = new CartonMasterService();
        this.MappingService = new MappingService();
        this.TertiaryPackingService = new TertiaryPackingService();
        this.PrintSecondaryPackagingService = new PrintSecondaryPackagingService();
        this.tblResponse = new tableRequest();
        this.state = {
            globalFilter: null,
            visible: false,
            sortIcon: false,
            Loader1: true,
            Loader2: false,
            sortOrder: '1',
            formError: {

            },
            CartonDDL: [],
            CartonId: [],
            buttonLabel: 'Submit',
            sales: [],
            scanItems: [],
            loading: true,
            first: 0,
            rows: 5,
            totalRecords: 0,
            globalFilter: null,
            emptyMessage: 'No Data found',
            IsDisabledCartonDDL: false,
            scanTxt: '' //KREP-55 defect

        }

        this.actionTemplate = this.actionTemplate.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.submitForm = this.submitForm.bind(this);

        this.onPage = this.onPage.bind(this);
        this.searchFilter = this.searchFilter.bind(this);
        //  this.openDialog = this.openDialog.bind(this);
        this.onSort = this.onSort.bind(this);

        this.ScanItem = this.ScanItem.bind(this);
    }
    //trigger api function on page call
    componentDidMount() {
        setTimeout(() => {
            this.GetTertiaryPacking();
        }, 1000);

        $('.p-column-title').on('click', function () {
            $(this).next().removeClass('pi-sort').toggleClass('pi-sort-up').addClass('pi-sort-down');
        });

        this.GetActiveCartonDDL();

    }

    // PAGE EVENT CALL
    onPage(event) {
        this.setState({
            loading: true
        });

        //imitate delay of a backend call
        setTimeout(() => {
            debugger

            this.getLazyLoadingValues(event);
            this.GetTertiaryPacking();

        }, 250);
    }

    // set lazy loading values
    getLazyLoadingValues(event) {
        this.setState({ rows: event.rows });
        this.tblResponse.PageSize = event.rows;
        this.tblResponse.First = event.first + 1;
        this.tblResponse.IsActive = true;
        this.tblResponse.SearchValue = event.globalFilter ? event.globalFilter : "";
        //this.tblResponse.SortColumn = event.sortField;
        this.tblResponse.SortOrder = event.sortOrder === 1 ? 'ASC' : 'DESC';
    }

    // get users data list from api
    GetTertiaryPacking() {
        this.tblResponse.SortColumn = '';
        debugger
        this.TertiaryPackingService.GetTertiaryPacking(this.tblResponse).then(data => {
            this.setState({ Loader2: true });
            const resdata = data.data;
            //if responsedata is not null
            if (resdata !== null && resdata.ResponseData !== null && resdata.ResponseData.length > 0) {
                this.datasource = resdata.ResponseData;
                this.setState({
                    totalRecords: resdata.ResponseData[0].TotalRows,
                    first: (this.tblResponse.First - 1),
                    sales: this.datasource.slice(0, ((this.tblResponse.First - 1) + this.tblResponse.PageSize)),
                    loading: false
                });
            }
            //if responsedata is null
            else {
                this.datasource = null;
                this.setState({
                    totalRecords: 0,
                    first: 1,
                    sales: null,
                    loading: false
                });
            }
        });
    }

    // call every change of form and validation part also
    handleChange(event) {

        const { name, value } = event.target;
        let errors = this.state.formError;

        const isValid = this.validateForm(value, name);
        this.setState({ errors, [name]: value });
    }

    // validate form
    validateForm(value, name) {
        let errors = this.state.formError;
        let IsValid = true;
        //to validate each form field with required conditions
        switch (name) {
            case 'UserName':
                if (value.length < 1) {
                    IsValid = false;
                    errors.UserName = "Please enter your username.";
                } else errors.UserName = ''
                break;

            default:
                break;
        }

        return IsValid;
    }

    // reset form text value
    formReset() {
        this.setState({
            ReferenceID: '',
            UserName: '',
            FirstName: '',
            LastName: '',
            Email: '',
            MobileNo: '',
            Password: '',
            ConfirmPassword: '',
            IsActive: true

        });
        let errors = this.state.formError;
        Object.entries(errors).map(([key, value]) => {
            errors[key] = '';
        });
    }



    // open Dialog
    openDialog() {
        this.setState({ visible: true });
        this.formReset();
    }

    // submit packing
    submitForm(event) {
        event.preventDefault();

        if (this.state.CartonId.length == 0) {
            this.refs.Messchild.showWarn("Select Carton Size");
            return;
        }
        else if (this.state.scanItems.length == 0) {
            this.refs.Messchild.showWarn("Scan First");
            return;
        }

        //if(this.state.CartonId.ca)


        else {
            this.setState({ Loader1: false });
            const formData = {

                //createdBy
                cartonMasterId: this.state.CartonId.CartonId,
                scanned: this.state.scanItems,
            }

            setTimeout(() => {
                this.TertiaryPackingService.Save(formData).then(data => {
                    this.setState({ Loader1: true });
                    const resdata = data.data;
                    //if ResponseCode is 200 success else error or warning message
                    if (resdata !== null && resdata.ResponseCode === '200') {

                        this.refs.Messchild.showSuccess(resdata.ResponseMessage);
                        this.PrintSecondaryPackagingService.formPreview1([resdata.ResponseData]);
                        // this.setState({
                        //     loading: true,
                        //     visible: false
                        // });
                        this.setState({
                            IsDisabledCartonDDL: false
                        });

                        this.state.scanItems = [];
                        this.setState({
                            scanItems: []
                        });
                        this.GetTertiaryPacking();

                    } else if (resdata.ResponseCode === '400') {
                        this.refs.Messchild.showWarn(resdata.ResponseMessage);
                    } else {
                        this.refs.Messchild.showError(resdata.ResponseMessage);
                    }
                });
            }, 1000);
        }
    }

    // get active carton drop down list
    GetActiveCartonDDL() {
        debugger
        this.CartonMasterService.GetActiveCartonDDL().then(data => {
            const resdata = data.data;
            //if ResponseData is not null
            if (resdata !== null && resdata.ResponseCode === '200') {
                this.setState({
                    CartonDDL: resdata.ResponseData
                });
            }
        });
    }

    // scan qr code
    ScanItem(e) {
        if (e.key === 'Enter') {
            let qr = e.target.value;

            if (this.state.CartonId.length == 0) {
                this.refs.Messchild.showWarn("Select Carton Size");
                return;
            }
            else if (this.state.CartonId.CartonSize == this.state.scanItems.length) {
                this.refs.Messchild.showWarn("Carton Full");
                return;
            }

            if (qr.includes("SID")) {

                console.log(qr);

                //const fObj = {UID : qr}
                this.TertiaryPackingService.GetScanSecondaryPacking(qr).then(data => {

                    debugger
                    const resdata = data.data;
                    //if ResponseCode is 200 success else error or warning message
                    if (resdata.ResponseData != null && resdata.ResponseCode === "200") {

                        var res = resdata.ResponseData;

                        if (this.state.scanItems.length > 0) {
                            let checkseqNo = this.state.scanItems.filter(y => y.CartonId == res.CartonId)

                            if (checkseqNo.length > 0) {
                                this.refs.Messchild.showWarn("already Scanned");
                                return;
                            }
                            if (this.state.scanItems[0].SPD[0].ProductId != res.SPD[0].ProductId) {
                                this.refs.Messchild.showWarn("You can pack only same product");
                                return;

                            }


                        }

                        this.state.scanItems.push(res);
                        this.setState({
                            scanItems: this.state.scanItems
                        });
                        this.setState({
                            IsDisabledCartonDDL: true,
                            scanTxt: ""
                        });



                    }
                    else
                        this.refs.Messchild.showWarn(resdata.ResponseMessage);
                });

            }
            else {
                this.refs.Messchild.showWarn("Invalid Scanned");
            }
            this.setState({
                scanTxt: ""
            });

        }
    }

    // delete user data
    deleteScanned(CartonId) {

        let arrayfilter = this.state.scanItems.filter(x => x.CartonId != CartonId);

        this.setState({
            scanItems: arrayfilter
        });

    }

    // seach table
    searchFilter(e) {
        this.setState({
            loading: true
        });
        this.tblResponse.SearchValue = e.target.value;
        this.GetTertiaryPacking();
    }

    callbackFunction = (childData) => {
        this.setState({ message: childData })
    }

    // disabled checkbox
    activeTemplate(rowData, column) {
        return (
            <input type="checkbox" disabled checked={rowData.IsActive} />
        )
    }

    // Sort table
    onSort(event) {
        this.setState({ sortOrder: this.state.sortOrder === 1 ? 2 : 1, sortIcon: !this.state.sortIcon });
        const sortField = event.sortField == "CreatedDt" ? "CreatedDt" : event.sortField;
        this.tblResponse.SortColumn = sortField ? sortField : "";
        this.tblResponse.SortOrder = this.state.sortOrder === 1 ? 'DESC' : 'ASC';
        this.GetTertiaryPacking();
        const clickData = document.getElementsByClassName("p-sortable-column-icon pi pi-fw pi-sort");
        console.log(event);
    }

    // edit form 
    actionTemplate(rowData, column) {


        const deleteFunc = () => {

            confirmAlert({
                title: 'Confirm to delete',
                message: 'Are you sure to do this.',
                buttons: [
                    {
                        label: 'Yes',
                        onClick: () => this.deleteScanned(rowData.CartonId)

                    },
                    {
                        label: 'No',
                        onClick: () => null
                    }
                ]
            });
        }

        return <span>

            <Button type="button" icon="pi pi-trash" onClick={deleteFunc} className="p-button-danger"></Button>
        </span>;
    }

    // create html part
    render() {
        let header = (
            <div className="row">
                <div className="col-md-8 text-left">
                    <form className="form-inline">

                        <div className="form-group">
                            <label className="ml-2 mr-2">Carton Size:</label>
                            <Dropdown optionLabel="CartonName" onChange={e => { this.handleChange(e) }} value={this.state.CartonId} className="form-control" placeholder="Select Carton" name="CartonId" options={this.state.CartonDDL} />
                            {this.state.formError.CartonId !== null ?
                                <div className='error'>{this.state.formError.CartonId}</div> : null}
                        </div><div className="ml-4 form-group">
                            <label>Scan items:</label>
                            {/* <input  value={this.state.scanTxt} type="search" className="form-control ml-2" id="scan" onChange={e => {this.ScanItem(e) }} /> */}
                            <input onChange={e => { this.handleChange(e) }} name="scanTxt" value={this.state.scanTxt} type="search" className="form-control ml-2" id="scan" onKeyDown={e => { this.ScanItem(e) }} />

                        </div>
                    </form>


                </div>
                <div className="col-md-4">
                    <i className="pi pi-search" style={{ margin: '4px 4px 0 0' }}></i>

                    <InputText type="search" onInput={(e) => this.setState({ globalFilter: e.target.value })} placeholder="Global Search" size="30" />
                </div>

            </div>
        );

        let header2 = (
            <div className="row">

                <div className="col-md-4">
                    <i className="pi pi-search" style={{ margin: '4px 4px 0 0' }}></i>
                    <InputText type="search" onInput={this.searchFilter} placeholder="Global Search" size="30" />
                </div>

            </div>
        );

        return (
            <>
                <MessageComponent ref="Messchild" />
                <ConfirmationModal parentCallback={this.callbackFunction} ref="child" />
                <div className="heading">
                    <h1>Tertiary Packing</h1>
                    {/* <Button label="Add Packing" icon="pi pi-plus-circle" onClick={this.openDialog} /> */}
                </div>
                <Loaders loader={this.state.Loader1} classType="small" />
                <DataTable responsive={true} header={header}
                    emptyMessage={this.state.emptyMessage} value={this.state.scanItems} sortMode="multiple" paginator={true}
                    rows={this.state.rows}
                    globalFilter={this.state.globalFilter}
                    className="tblAuto">
                    <Column field="CartonId" header="Carton Id" sortable={true} />
                    <Column field="TotalQty" header="Total Qty" sortable="custom" />
                    <Column field="CreatedDt" header="Created Date" sortable={true} />
                    <Column body={this.actionTemplate} header="Action" />
                </DataTable>

                <div className="col-md-12 text-center mt-4 mb-4">
                    <button className="btn btn-primary mt-4" onClick={this.submitForm}  >Submit</button>
                </div>



                <div className="col-md-12 p-0">
                    <Loaders loader={this.state.Loader2} classType="small" />
                    <DataTable responsive={true} style={{ width: '100%' }} header={header2} globalFilter={this.state.globalFilter}
                        emptyMessage={this.state.emptyMessage} value={this.state.sales} sortMode="multiple" paginator={true}
                        rows={this.state.rows} rowsPerPageOptions={[5, 10, 20]}
                        totalRecords={this.state.totalRecords} lazy={true} first={this.state.first}
                        onPage={this.onPage} onSort={this.onSort} className="tblAuto">
                        <Column field="TertiaryCartonId" header="Carton Id" headerStyle={{ width: '250px' }} sortable={true} />
                        <Column field="TotalSecondaryCarton" header="Total Carton" headerStyle={{ width: '250px' }} sortable="custom" />
                        <Column field="CreatedDt" header="Created Date" headerStyle={{ width: '250px' }} sortable={true} />
                        <Column field="CartonName" headerStyle={{ width: '250px' }} header="Carton Size" sortable={true} />
                    </DataTable>
                </div>
            </>
        )
    }
}